export default "__VITE_ASSET__C2P_H9e2__";